import React from 'react';
import Projects from '../../api/project'
import { Link } from 'react-router-dom'

import ProjectSectionS4 from '../../components/ProjectsS4';

const RelatedProject = () => {


    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div className="wpo-project-single-item">
            <div className="wpo-project-single-title">
                <h3>Projets connexes</h3>
            </div>
            <div className="wpo-project-area-s2 ">
                <div className="row align-items-center">
                    <div className="wpo-project-wrap">
                        <div className="sortable-gallery">
                            <div className="row">
                                <div className="col-lg-12">
                                <ProjectSectionS4/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};
export default RelatedProject;

